module.exports = __webpack_public_path__ + "79d6f4a58b1bc115d171fba42cb3868e.svg";